function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  width: 24,
  height: 24,
  fill: "#D9D9D9"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2223_2585)"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon",
  d: "M13.2923 12.0001L8.69226 7.40008L9.39996 6.69238L14.7077 12.0001L9.39996 17.3078L8.69226 16.6001L13.2923 12.0001Z",
  fill: "var(--n-color-text-dark)"
}));

function SvgIconChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chevron_right"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2223_2585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _ref), _ref2));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.6918e9aaca7180dff0bee09686f6702b.svg";
export { ForwardRef as ReactComponent };